

import React, { ReactNode } from 'react';
import { Grid, Theme, useTheme } from "@mui/material";
import { SxProps } from '@mui/system';


export type FormPropertyProps = {
    sx?: SxProps<Theme>;
    children: ReactNode
};

export default function FormProperty({children,
    sx} : FormPropertyProps) {
   
    const theme = useTheme();
    return (
        <Grid
            sx={{
                paddingRight: theme.spacing(2),
                paddingBottom: theme.spacing(2),
                ...sx}}
            size={{
                xs: 12,
                sm: 6,
                md: 4
            }}>
            {children}
        </Grid>
    );
  }
